import { DAY_OF_WEEK } from "@/const/Constants";
import OptionConst from "@/const/Option";
import { DakokuData } from "@/types/Dakoku";
import { computed, reactive, Ref, ref } from "vue";

/*
 * 初期処理
 */
export function useDakokuInit() {
  const dakokuData: Ref<DakokuData | null> = ref(null);

  // 打刻時間表示
  const displayData = reactive({
    date: computed(() => {
      if (!dakokuData.value) {
        return ''
      }

      if (!dakokuData.value.dakoku_date) {
        return ''
      }

      if (!(dakokuData.value.dakoku_date instanceof Date)) {
        return ''
      }

      const date = dakokuData.value.dakoku_date;
      return (
        date.getFullYear() +
        '年' +
        (date.getMonth() + 1) +
        '月' +
        date.getDate() +
        '日' +
        '(' + DAY_OF_WEEK[date.getDay()] + ')'
      )
    }),
    // 出勤
    syukkin: computed(() => {
      if (!dakokuData.value) {
        return ''
      }

      if (!dakokuData.value.syukkin_datetime) {
        return ''
      }

      if (!(dakokuData.value.syukkin_datetime instanceof Date)) {
        return ''
      }

      const datetime = dakokuData.value.syukkin_datetime;
      return (
        datetime.getHours() +
        "時" +
        datetime.getMinutes() +
        "分"
      )
    }),
    // 退勤
    taikin: computed(() => {
      if (!dakokuData.value) {
        return ''
      }

      if (!dakokuData.value.taikin_datetime) {
        return ''
      }

      if (!(dakokuData.value.taikin_datetime instanceof Date)) {
        return ''
      }

      const datetime = dakokuData.value.taikin_datetime;
      return (
        datetime.getHours() +
        "時" +
        datetime.getMinutes() +
        "分"
      )
    }
    ),
    // 外出
    gaisyutsu: computed(() => {
      if (!dakokuData.value) {
        return ''
      }

      if (!dakokuData.value.gaisyutsu_datetime) {
        return ''
      }

      if (!(dakokuData.value.gaisyutsu_datetime instanceof Date)) {
        return ''
      }

      const datetime = dakokuData.value.gaisyutsu_datetime;
      return (
        datetime.getHours() +
        "時" +
        datetime.getMinutes() +
        "分"
      )
    }),
    // 戻り
    modori: computed(() => {
      if (!dakokuData.value) {
        return ''
      }

      if (!dakokuData.value.modori_datetime) {
        return ''
      }

      if (!(dakokuData.value.modori_datetime instanceof Date)) {
        return ''
      }
      const datetime = dakokuData.value.modori_datetime;

      return (
        datetime.getHours() +
        "時" +
        datetime.getMinutes() +
        "分"
      )
    }),
    // 休憩時間
    kyuukei: computed(() => {
      if (!dakokuData.value) {
        return ''
      }
      if (dakokuData.value.kyuukei_times !== null) {
        return dakokuData.value.kyuukei_times + '分'
      }

      return '未取得';
    }),
  })

  // 休憩時間登録時の日時をセット（退勤した日時を基準にする)
  const targetDate = (() => {
    if (!dakokuData.value) {
      return null
    }

    if (!dakokuData.value.dakoku_date) {
      return null
    }

    if (!(dakokuData.value.dakoku_date instanceof Date)) {
      return null
    }

    return dakokuData.value.dakoku_date
  })

  const isSyouninDakoku = computed(() =>{
    return dakokuData.value?.syounin_status_type == OptionConst.SYOUNIN_STATUS.APPROVED
  })

  return {
    dakokuData,
    displayData,
    targetDate,
    isSyouninDakoku
  }
}
